import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SplitPartsPipe } from '../../pipes/split-parts.pipe';

@Component({
  selector: 'app-metric-card',
  standalone: true,
  imports: [CommonModule, SplitPartsPipe],
  templateUrl: './metric-card.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./metric-card.component.scss'],
})
export class MetricCardComponent {
  @Input() title = '';
  @Input() baseCurrency: string | undefined;
  @Input() baseCurrencyDisplayPrecision: number | undefined;
  @Input() value: string | number | undefined;
  @Input() currencyDisplay: 'symbol' | 'code' | 'name' | string = 'symbol';
  @Input() loading = false;
  @Input() cardClass = '';
  @Input() type = '';

  @Input() titleStyle: Record<string, string> = {};
  @Input() cardStyle: Record<string, string> = {};
}
